export default "__VITE_ASSET__2PQu2tHt__"